import MediaLibrary from './MediaLibrary'
import { useMedia } from '../utils/hooks'

const MediaLibraryOutlet = () => {
  const { media } = useMedia()
  if (!media) return null
  return (
    <MediaLibrary fixedType={media.fileType} handleSelect={media.onSelect} />
  )
}

export default MediaLibraryOutlet
